import React, { useState } from "react";
import { useMutation } from "@apollo/client";

import loadIcon from "../../../assets/images/tail-spin.svg";

import ModalHolder from "../../molecules/ModalHolder";

import { ACCEPT_OR_REJECT_INITIATIVE_REFERRAL } from "../../../shared/queries";
import { toastError, toastSuccess } from "../../../shared/helpers";

import { H3, H5, P } from "../../atoms/Texts";
import { Badge, PrimaryButton } from "../../atoms/Buttons";
import { useParams } from "react-router";

const AcceptOrRejectInitiativeReferral = ({
  header,
  text,
  closeModal,
  referral,
  type,
}) => {
  const { user, from } = referral;
  const { id } = useParams();

  const [badgeColor, setBadgeColor] = useState({});

  React.useEffect(() => {
    switch (true) {
      case from === "form":
        setBadgeColor({
          bgColor: "#FDD2DC",
          textColor: "#7C033C",
        });
        break;

      case from === "sdep":
        setBadgeColor({
          bgColor: "#D8FDEC",
          textColor: "#167C3C",
        });
        break;

      default:
        setBadgeColor({
          bgColor: "#DCD6FE",
          textColor: "#2220A9",
        });
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [acceptOrRejectReferral, { loading }] = useMutation(
    ACCEPT_OR_REJECT_INITIATIVE_REFERRAL,
  );

  const onacceptOrRejectReferral = () => {
    acceptOrRejectReferral({
      variables: {
        data: {
          referralId: referral.id,
          organizationId: id,
          status: type === "approved" ? "approved" : "rejected",
        },
      },
    })
      .then(() => {
        toastSuccess(`Referral ${type} successfully`);
        closeModal();
        window.location.reload();
      })
      .catch((error) => {
        toastError(error.message);
      });
  };

  return (
    <ModalHolder width="400px" closeModal={closeModal}>
      <div className="pb-12 ">
        <H3 color="#22202D" fontFamily="medium" className="text-center">
          {header}
        </H3>
        <P
          fontSize="14px"
          color="#7D7B96"
          className="text-center mx-auto mt-2 mb-12"
        >
          {text}
        </P>
        <div className="items-center">
          <div
            className="w-16 h-16 flex mx-auto items-center justify-center rounded-lg mb-3"
            style={{ background: "#EAE7FE" }}
          >
            <H5 color="#12046D" className="capitalize profile-dropdown-child">
              {`${user?.firstName?.[0]} ${user?.lastName?.[0]}`}
            </H5>
          </div>
          <H5
            color="#716E8B"
            fontSize="16px"
            smallSize="16px"
            className="mb-2 font-semibold text-center"
          >
            {`${user?.firstName} ${user?.lastName}`}
          </H5>
          <P
            color="#716E8B"
            fontSize="13px"
            smallSize="13px"
            className="my-0 text-center"
          >
            {user?.email}
          </P>
          <div className="flex items-center justify-center mt-3 mb-16">
            <Badge
              fontFamily="medium"
              bg={badgeColor.bgColor}
              color={badgeColor.textColor}
              className="uppercase"
              fontSize="12px"
            >
              {from}
            </Badge>
          </div>
        </div>

        <div className="flex">
          <PrimaryButton.Light
            type="button"
            onClick={closeModal}
            className="w-1/2"
            disabled={loading}
          >
            {!loading ? (
              "Cancel"
            ) : (
              <img src={loadIcon} alt="Loading" className="mx-auto h-6 w-6" />
            )}
          </PrimaryButton.Light>
          <PrimaryButton
            className="w-full ml-10"
            disabled={loading}
            onClick={() => onacceptOrRejectReferral("approved")}
          >
            {!loading ? (
              "Confirm"
            ) : (
              <img src={loadIcon} alt="Loading" className="mx-auto h-6 w-6" />
            )}
          </PrimaryButton>
        </div>
      </div>
    </ModalHolder>
  );
};

export default AcceptOrRejectInitiativeReferral;
